<div class="modal-body">
  <h3>{{messageHeader}}</h3>
  <p class="fw-bold" *ngIf="popupText1">{{popupText1}}</p>
  <p *ngIf="popupText2">{{popupText2}}</p>
</div>


<div class="modal-footer justify-content-center">
    <button type="button" 
          class="btn btn-success" 
          (click)="yes()">
    Yes
  </button>
  <button type="button" 
          class="btn btn-danger" 
          (click)="no()">
    No
  </button>

</div>